import { getRequest, patchRequest, postRequest, putRequest } from "utils/helpers/common/http-methods";



export const POLICIES_APIS = {
    createPolicy: (body: any) => postRequest(`/policies`, body),
    getPolicies: (params: any) => getRequest(`/privacy-policy`, params),
    editPolicyByID: (id: number, params: any) => patchRequest(`/privacy-policy/${id}`, params),
    getPolicyById: (id: number) => getRequest(`/privacy-policy/${id}`),
};
